import { CategoryMapper } from 'src/ConsentManagement/Mappers/CategoryMapper';
import { SaveSelectedOptions, GetSelectedOptions } from 'src/ConsentManagement/Repositories/ConsentOptionRepository';
import { SaveCurrentVendorSnapshot } from 'src/ConsentManagement/Services/VendorStorageService';
import { GetAllOptionIds } from 'src/ConsentManagement/Content/Preferences/PreferenceModel';
import * as ConsentLogger from 'src/ConsentManagement/Logging/ConsentLogger';
import * as ErrorLogger from 'src/ConsentManagement/Logging/ErrorLogger';
import { utag } from './Tealium/Tealium';

const SetConsent = async (options: number[], areVendorsFullyOn = true): Promise<void> => {
  const categoryOptions = areVendorsFullyOn ? options : [];
  const categories = CategoryMapper.map(categoryOptions);

  if (utag != null && utag.gdpr != null) {
    utag.gdpr.setPreferencesValues(categories);
  } else {
    ErrorLogger.log('Utag is not defined');
  }

  SaveSelectedOptions(options);
  SaveCurrentVendorSnapshot();
  ConsentLogger.logConsent(GetConsentLevel(categoryOptions), categoryOptions, categories);
};

const GetConsent = (): number[] => {
  return GetSelectedOptions();
};

const AcceptAllConsent = async (): Promise<void> => {
  SetConsent(GetAllOptionIds());
};

const GetConsentLevel = (options: number[]): ConsentLogger.ConsentLevel => {
  const sortNumeric = (a: number, b: number) => a - b;

  const getAllOptionsSorted = GetAllOptionIds().sort(sortNumeric);
  const getSelectedOptionsSorted = options.sort(sortNumeric);

  const allOptions = getAllOptionsSorted.join();
  const selectedOptions = getSelectedOptionsSorted.join();

  return allOptions === selectedOptions ? ConsentLogger.ConsentLevel.Full : ConsentLogger.ConsentLevel.Partial;
};

export { SetConsent, AcceptAllConsent, GetConsent };
